export enum Formulas {
  EVA_PRO = "EVA_PRO",
  EVA_360 = "EVA_360",
}
export enum FormulaTypes {
  LIGHT = "LIGHT",
  EXPERT = "EXPERT",
}

export enum FormulaLevel {
  EVA_PRO = 1,
  EVA_360 = 2,
}

export enum SubscriptionEnvs {
  MAIN_V3 = "MAIN-V3",
  NEXT_V3 = "NEXT-V3",
}

export interface Formula {
  formulaType: FormulaTypes;
  id: Formulas;
  name: string;
  badge: string;
  monthlyPrices: { [key: string]: number };
  yearlyPrices: { [key: string]: number };
  lifetimePrices: { [key: string]: number };
  lifetimePricesDiscount: { [key: string]: number };
  customPrice: boolean;
  subPriceText: string;
  buttonText: string;
  upperFeatureText: string;
  features: string[];
  summaryFeatures?: string[];
  detailedFeatures?: string[];
  optionalFeatures?: string[];
  priceLabel?: string;
  priceHeadline?: string;
  priceHeadlineSuffix?: string;
  priceCaption?: string;
  image: string;
  recommended: boolean;
  active: boolean;
  available: boolean;
}
